module.exports = __webpack_public_path__ + "img/WINLINE.6ac1e33e.svg";